import React from "react";

export default function SimpleValidationMessageView(props: { message: string }): React.ReactElement {
    return <div className="text-danger small mt-1">{props.message}</div>;
}
